<template>
  <div class="py-4 container-fluid">
    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h4 class="text-white">Expediente Digital: {{ client.name || 'Cargando...' }}</h4>
        <button @click="$router.go(-1)" class="btn btn-sm bg-white text-dark shadow-sm">
          <i class="fas fa-arrow-left me-1"></i> Volver
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="card card-profile mb-4 shadow-lg border-0">
          <div class="card-header bg-gradient-success p-4" style="height: 80px;"></div>
          <div class="card-body text-center p-3">
            <div class="mt-n6 mb-3">
              <img :src="client.photo_url || '/img/default-avatar.png'"
                class="rounded-circle img-fluid border border-3 border-white bg-white shadow-sm"
                style="width: 110px; height: 110px; object-fit: cover;">
            </div>
            <h5 class="mb-0 font-weight-bolder">{{ client.name }}</h5>
            <p class="text-sm text-secondary mb-1">{{ client.document }}</p>
            <div class="d-flex justify-content-center gap-2 mt-2">

              <span v-if="client.city" class="badge badge-pill bg-soft-info text-info border border-info">
                {{ client.city }}
              </span>
            </div>
          </div>
        </div>

        <div class="card shadow-sm border-0 mb-4">
          <div class="card-body p-3">
            <h6 class="text-uppercase text-dark text-xs font-weight-bolder opacity-7 mb-3">Información de Contacto</h6>
            <ul class="list-group">
              <li class="list-group-item border-0 ps-0 text-sm"><strong class="text-dark">Teléfono:</strong> {{ client.phone || 'No registrado' }}</li>
              <li class="list-group-item border-0 ps-0 text-sm"><strong class="text-dark">Email:</strong> {{ client.email || 'No registrado' }}</li>
              <li class="list-group-item border-0 ps-0 text-sm"><strong class="text-dark">Dirección:</strong> {{ client.address }}</li>
            </ul>
          </div>
        </div>

        <div v-if="client.document_front_url || client.document_back_url" class="card shadow-sm border-0">
          <div class="card-header pb-0 bg-white"><h6>Documentos</h6></div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-6" v-if="client.document_front_url">
                <img :src="client.document_front_url" class="img-fluid border-radius-lg shadow-sm">
                <p class="text-center text-xxs mt-2">Frente</p>
              </div>
              <div class="col-6" v-if="client.document_back_url">
                <img :src="client.document_back_url" class="img-fluid border-radius-lg shadow-sm">
                <p class="text-center text-xxs mt-2">Reverso</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="card shadow-sm border-0 text-center p-3">
              <h6 class="text-xs text-secondary text-uppercase font-weight-bold mb-1">Total Gestiones</h6>
              <h4 class="mb-0">{{ safeHistory.length }}</h4>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card shadow-sm border-0 text-center p-3">
              <h6 class="text-xs text-success text-uppercase font-weight-bold mb-1">Efectividad de Cobro</h6>
              <h4 class="mb-0">{{ totalCollectedPercentage }}%</h4>
            </div>
          </div>
        </div>

        <div class="card shadow-lg border-0">
          <div class="card-header pb-0 bg-white">
            <h6 class="font-weight-bolder">Historial de Tareas y Cobranza</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="loadingHistory" class="text-center p-5">
              <div class="spinner-border text-success" role="status"></div>
            </div>

            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead class="bg-gray-100">
                  <tr>
                    <th class="text-xxs font-weight-bolder opacity-7 ps-4">Fecha / Tipo</th>
                    <th class="text-xxs font-weight-bolder opacity-7">Monto / Recaudo</th>
                    <th class="text-xxs font-weight-bolder opacity-7">Estado / Notas</th>
                    <th class="text-xxs font-weight-bolder opacity-7">Gestor</th>
                    <th class="text-xxs font-weight-bolder opacity-7 text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="task in safeHistory" :key="task.task_id">
                    <td class="ps-4">
                      <div class="d-flex flex-column">
                        <span class="text-xs font-weight-bold text-dark">{{ formatDate(task.completed_at || task.due_date) }}</span>
                        <span class="text-xxs text-secondary">{{ task.type_name }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <span class="text-xs text-dark font-weight-bold">Meta: ${{ task.to_collect }}</span>
                        <span class="text-xs text-success font-weight-bold">Cobró: ${{ task.collected }}</span>
                      </div>
                    </td>
                    <td>
                      <span class="badge badge-sm rounded-pill mb-1"
                        :class="task.status === 'Completed' ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ task.status }}
                      </span>
                      <p class="text-xxs text-muted mb-0 text-truncate" style="max-width: 150px;">{{ task.comments }}</p>
                    </td>
                    <td class="text-xs text-dark">{{ task.user_name }}</td>
                    <td class="text-center">
                      <button @click="viewDetails(task)" class="btn btn-link text-info p-0 text-sm">
                        <i class="fas fa-eye"></i> Ver Detalle
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="taskModal" tabindex="-1" ref="taskModal" style="background: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg">
            <div class="modal-header bg-gradient-dark py-3">
                <h6 class="modal-title text-white">
                <i class="fas fa-file-invoice-dollar me-2"></i>
                Resumen de Gestión #{{ selectedTask.task_id }}
                </h6>
                <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <div class="modal-body p-4">
                <div class="row">
                <div class="col-md-5 text-center border-end">
                    <label class="text-xs font-weight-bold text-uppercase opacity-7">Evidencia Fotográfica</label>
                    <div class="mt-2">
                    <img :src="selectedTask.evidence_url || '/img/no-image.png'"
                        class="img-fluid border-radius-lg shadow-sm border"
                        style="max-height: 380px; width: 100%; object-fit: cover;"
                        @error="(e) => e.target.src = 'https://via.placeholder.com/400x500?text=Sin+Foto+de+Evidencia'">
                    </div>
                </div>

                <div class="col-md-7 ps-md-4">
                    <div class="row mb-4 mt-2">
                    <div class="col-6">
                        <div class="bg-gray-100 p-3 border-radius-lg text-center">
                        <h6 class="text-xxs text-uppercase text-secondary mb-1">Monto a Cobrar</h6>
                        <h5 class="text-dark mb-0 font-weight-bolder">${{ selectedTask.to_collect }}</h5>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="bg-soft-success p-3 border-radius-lg text-center border border-success">
                        <h6 class="text-xxs text-uppercase text-success mb-1">Monto Recaudado</h6>
                        <h5 class="text-success mb-0 font-weight-bolder">${{ selectedTask.collected }}</h5>
                        </div>
                    </div>
                    </div>

                    <h6 class="text-xs font-weight-bold text-uppercase opacity-7 mb-3">Detalles de la Gestión</h6>

                    <div class="d-flex mb-3">
                    <i class="fas fa-calendar-alt text-sm me-3 text-secondary"></i>
                    <div>
                        <span class="text-xxs text-secondary d-block">Programada / Finalizada</span>
                        <span class="text-xs font-weight-bold">{{ selectedTask.due_date }} / {{ selectedTask.completed_at || 'N/A' }}</span>
                    </div>
                    </div>

                    <div class="d-flex mb-3">
                    <i class="fas fa-user-tie text-sm me-3 text-secondary"></i>
                    <div>
                        <span class="text-xxs text-secondary d-block">Gestor Responsable</span>
                        <span class="text-xs font-weight-bold">{{ selectedTask.user_name }}</span>
                    </div>
                    </div>

                    <div class="d-flex mb-4">
                    <i class="fas fa-tag text-sm me-3 text-secondary"></i>
                    <div>
                        <span class="text-xxs text-secondary d-block">Tipo de Gestión</span>
                        <span class="text-xs font-weight-bold">{{ selectedTask.type_name }}</span>
                    </div>
                    </div>

                    <div class="mb-0">
                    <label class="text-xs font-weight-bold text-uppercase opacity-7">Notas del Gestor</label>
                    <div class="bg-light p-3 border-radius-md text-sm shadow-none mt-1 border" style="min-height: 80px;">
                        <i class="text-muted">"{{ selectedTask.comments || 'Sin observaciones registradas.' }}"</i>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <div class="modal-footer bg-gray-100">
                <div class="w-100 d-flex justify-content-between align-items-center">
                <span class="text-xxs text-secondary">ID Tarea: {{ selectedTask.task_id }}</span>
                <button type="button" class="btn btn-sm bg-gradient-secondary mb-0 px-4" @click="closeModal">Cerrar</button>
                </div>
            </div>
            </div>
        </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";
import { Modal } from 'bootstrap';

export default {
  props: ['id'],
  data() {
    return {
      client: {},
      history: [],
      loadingHistory: true,
      selectedTask: {},
      modalInstance: null,
      companyId: localStorage.getItem('companyId')
    };
  },
  computed: {
    safeHistory() {
      return Array.isArray(this.history) ? this.history : [];
    },
    totalCollectedPercentage() {
      const history = this.safeHistory;
      if (history.length === 0) return 0;
      const totalToCollect = history.reduce((acc, task) => acc + parseFloat(task.to_collect || 0), 0);
      const totalCollected = history.reduce((acc, task) => acc + parseFloat(task.collected || 0), 0);
      return totalToCollect > 0 ? ((totalCollected / totalToCollect) * 100).toFixed(1) : 0;
    }
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      const token = localStorage.getItem("accessToken");
      const config = { headers: { 'Authorization': `Bearer ${token}` } };
      this.loadingHistory = true;
      try {
        const [clientRes, historyRes] = await Promise.all([
          axios.get(`${this.$store.state.apiURL}clients/${this.id}`, config),
          axios.get(`${this.$store.state.apiURL}reports/tasks?type=client_history&client_id=${this.id}&company_id=${this.companyId}`, config)
        ]);
        this.client = clientRes.data;
        this.history = historyRes.data;
      } catch (error) {
        console.error("Error cargando expediente:", error);
      } finally {
        this.loadingHistory = false;
      }
    },
    viewDetails(task) {
      this.selectedTask = task;
      if (!this.modalInstance) {
        this.modalInstance = new Modal(this.$refs.taskModal, {
          backdrop: false // Evita que el fondo oscuro bloquee la UI
        });
      }
      this.modalInstance.show();
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return date.split(' ')[0];
    }
  }
};
</script>

<style scoped>
.mt-n6 { margin-top: -3.5rem !important; }
.bg-soft-success { background-color: rgba(45, 206, 137, 0.1); }
.bg-soft-info { background-color: rgba(17, 205, 239, 0.1); }
.card-profile .card-header { height: 100px; }
.modal-lg { max-width: 850px; }
/* Asegura que el modal esté encima del fondo */
.modal { z-index: 1060 !important; }
</style>